
import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { DiscountsContent } from '@/components/admin/discounts/DiscountsContent';

export default function Discounts() {
  return (
    <AdminLayout>
      <DiscountsContent />
    </AdminLayout>
  );
}
